/**
 * 考试环形图demo
 * @description 考试环形图demo
 * @author mll
 * @date 2020-3-9
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '../../../tool'
import { ExamPercent } from '../../../components'
let { WizUpload, WizIcon, WizButton, WizCard } = component_tool;
let { WizContainer } = framework_tool;

class ExamPercentDemo extends WizContainer {

    componentName = 'ExamPercentDemo';



    _render() {

        return (
            <WizCard title={'Percent Demo'} icon='0'>
                <ExamPercent
                    headerProps={{ title: '考试名称', value: '20191108考试模版1-温州宏祥汽车有限公司' }}
                    percentProps={{
                        data: [
                            {
                                item: "通过人次",
                                count: 10,
                            },
                            {
                                item: "未通过人次",
                                count: 20,
                            }
                        ],
                        dataFormat: {
                            type: "percent",
                            field: "count",
                            dimension: "item",
                            as: "percent"
                        },
                        count: 30,
                        centerText:'考试人次'
                    }}
                    itemProps={[
                        { img: constants.files.sys_main_logo, title: '最高分', value: '100分' },
                        { img: constants.files.sys_main_logo, title: '平均分', value: '80分' },
                        { img: constants.files.sys_main_logo, title: '最低分', value: '50分' }
                    ]}
                    footerView={<div>考试人数：2000人，在考人数：800人</div>}
                />
            </WizCard>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(ExamPercentDemo);
